// Client-side entry point for islands
import { autoHydrateIslands } from './Island';

// Import and register all islands
import { MetricsCard } from './MetricsCard';
import { D3ChartIsland } from './D3ChartIsland';
import { DashboardState } from './DashboardState';

import { registerIsland } from './Island';

// Register islands
registerIsland('MetricsCard', MetricsCard);
registerIsland('D3ChartIsland', D3ChartIsland);
registerIsland('DashboardState', DashboardState);

// Auto-hydrate all islands on page load
autoHydrateIslands();